if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              const productEmbroding = document.querySelector('product-embroding');

              // Exists and has class active
              if(productEmbroding && productEmbroding.classList.contains("active")) {
                const activeColor = productEmbroding.querySelector(".embroding-color-options .swatch-circle.active");

                if(activeColor) {
                  const selectedVariantId = activeColor.dataset.variantId;
                  const input = productEmbroding.querySelector(".embroding-input-wrapper input");
                  const embrodingText = input.value;
                  const productTitle = document.querySelector('.product__title h1').textContent.trim();
                  const productId = document.querySelector('product-form input[name="product-id"]').value;

                  const embrodingFormData = new FormData();
                  embrodingFormData.append('id', selectedVariantId);
                  embrodingFormData.append('quantity', 1);
                  embrodingFormData.append(`properties[${window.embrodingStrings.itemPropertyProduct}]`, productTitle);
                  embrodingFormData.append(`properties[${window.embrodingStrings.itemPropertyText}]`, embrodingText);
                  embrodingFormData.append('properties[_embroding', 'true')
                  embrodingFormData.append('properties[_embroding-product-id', productId)

                  config.body = embrodingFormData;

                  fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((state) => {
                      console.log("Embroding added to cart");
                    })
                    .catch((error) => {
                      window.console.error(error);
                    });
                }
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");

              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            document.querySelector("quick-add-drawer[open]")?.hide();
            const cartCountBubble = document.querySelector(
              ".cart-count-bubble span"
            );
            if (cartCountBubble) {
              const oldCartCount = parseInt(cartCountBubble.innerHTML);
              if (!isNaN(oldCartCount)) {
                cartCountBubble.innerHTML = oldCartCount + 1;
              } else {
                console.error("Invalid cart count value.");
              }
            } else {
              console.error("Cart count element not found.");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get("product-embroding")) {
  customElements.define(
    "product-embroding",
    class ProductEmbroding extends HTMLElement {
      constructor() {
        super();

        this.options = this.querySelectorAll(".embroding-options > div");

        this.options.forEach((option) => {
          option.addEventListener("click", this.handleOptionClick.bind(this));
        });

        this.colors = this.querySelectorAll(".embroding-color-options .swatch-circle");

        this.colors.forEach((color) => {
          color.addEventListener("click", this.handleColorClick.bind(this));
        });

        // Add value change listener to input field
        this.input = this.querySelector(".embroding-input-wrapper input");
        this.input.addEventListener("change", this.handleInputChange.bind(this));
      }

      handleOptionClick(e) {
        const option = e.target;
        const value = option.dataset.value;

        // Remove selected from all options
        this.options.forEach((option) => {
          option.classList.remove("selected");
        })

        // Add selected to clicked option
        option.classList.add("selected");

        if(value == "true") {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      }

      handleColorClick(e) {
        const color = e.target;
        // const value = color.dataset.value;

        // Remove selected from all colors
        this.colors.forEach((color) => {
          color.classList.remove("active");
        })

        // Add selected to clicked color
        color.classList.add("active");

        const selectedColorEl = this.querySelector(".embroding-selected-color");

        if(selectedColorEl) {
          const swatchName = color.dataset.swatchName;
          selectedColorEl.textContent = swatchName;
        }

        const previewImgEl = this.querySelector('.embroding-preview > img');

        if(previewImgEl) {
          const imgSrc = color.dataset.productImage;
          previewImgEl.src = imgSrc;
        }
      }

      handleInputChange(e) {
        // Max 3 characters
        if(e.target.value.length > 3) {
          e.target.value = e.target.value.slice(0, 3);
        }
      }
    }
  );
}
